export default "__VITE_ASSET__e2afca29__"